@use '@design/design-tokens/border-radius/border-radius' as *;

@layer chart {
  .resampleSelectorRoot {
    display: flex;
    @include border-radius-r2;
    padding: 4px;
    background-color: var(--surface-default);

    ul {
      width: 185px;
      max-height: 500px;
      overflow: auto;
    }

    li > div {
      margin: 8px 8px 8px 0;
    }

    li:nth-child(n + 5) {
      border-top: 1px solid var(--border-soft);
    }
  }

  .styledChip {
    white-space: nowrap;
  }
}
